module.exports = __webpack_public_path__ + "static/media/mobile-service-fullcycle.6093a47e.jpg";